import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useHelpDrawerStyles = makeStyles({
  body: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
    paddingBlock: tokens.spacingVerticalS,
  },
  empty: {
    color: tokens.colorNeutralForeground3,
    fontSize: fontScale.body,
    paddingBlock: tokens.spacingVerticalL,
    textAlign: 'center',
  },
});
